import { IError } from 'types/graphqlTypes'

export const hasCarrierComplianceError = (errors: IError[]): boolean => {
  return errors.map(({ message }) => message).includes('non_compliant_carrier')
}
